import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

export class TextareaCounter extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            textareaCounter: this.dom.el.querySelector('.m-textareaCounter'),
            circle: this.dom.textareaCounter
                ? this.dom.el.querySelectorAll('.k-c-circularProgressIndicator__circle')
                : false,
            count: this.dom.textareaCounter ? this.dom.el.querySelector('.m-textareaCounter__count') : false,
        };
    }

    getPropsFromDom() {
        return {
            strokeValue: this.dom.circle ? this.dom.circle[1].getAttribute('stroke-dasharray') : '0,100',
            count: this.dom.count ? this.dom.count.innerHTML : '',
            highlightRed: this.dom.circle
                ? this.dom.circle[1].querySelector('.k-c-circularProgressIndicator__circle--red') : false,
            highlightYellow: this.dom.circle
                ? this.dom.circle[1].querySelector('.k-c-circularProgressIndicator__circle--yellow') : false,
        };
    }

    updateCount(value) {
        const circleValue = (value / 500) * 100;

        if (value > 500) {
            this.updateProps({
                count: 500 - value,
                strokeValue: `${circleValue},100`,
                highlightRed: true,
                highlightYellow: false,
            }, true);
        } else if (value >= 480) {
            this.updateProps({
                count: 500 - value,
                strokeValue: `${circleValue},100`,
                highlightRed: false,
                highlightYellow: true,
            }, true);
        } else {
            this.updateProps({
                count: 500 - value,
                strokeValue: `${circleValue},100`,
                highlightRed: false,
                highlightYellow: false,
            }, true);
        }
    }
}
